import { Observable } from "../observable";
import "./icon.css";

class IconElement extends HTMLElement {
    $attributes = new Observable<{ value?: string }>({});

    static get observedAttributes() {
        return ["value"];
    }

    constructor() {
        super();
    }

    attributeChangedCallback(name: string, oldValue: string, newValue: string) {
        if (name === "value" && oldValue !== newValue) {
            this.$attributes.broadcast((prev) => ({
                ...prev,
                value: newValue,
            }));
        }
    }

    connectedCallback() {
        this.$attributes.subscribe(({ value }) => {
            if (value) {
                this.innerHTML = `<i class="iconoir-${value}"></i>`;
            } else {
                this.innerHTML = "";
            }
        }, true);
    }
}

customElements.define("bd-icon", IconElement);
